import { render, staticRenderFns } from "./user-orders.vue?vue&type=template&id=4055ee3f&lang=pug&"
import script from "./user-orders.vue?vue&type=script&lang=js&"
export * from "./user-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports